import { ClientType } from '../shared/schemas/ClientType'
import { ReleaseNotesRepository } from './domain/repositories/ReleaseNotesRepository'
import { releaseNotesAdapter } from './external/releaseNotesAdapter'
import { releaseNotesRepositoryAdapter } from './infra/releaseNotesRepositoryAdapter'

export const releaseNotesInstance = ReleaseNotes(
  releaseNotesRepositoryAdapter(releaseNotesAdapter)
)

export function ReleaseNotes(releaseNotesRepository: ReleaseNotesRepository) {
  return {
    async getReleaseNotes({
      clientType,
      versionMajorNumber,
      versionMinorNumber
    }: {
      clientType: ClientType
      versionMajorNumber: number
      versionMinorNumber: number
    }) {
      return await releaseNotesRepository.getReleaseNotes({
        clientType,
        versionMajorNumber,
        versionMinorNumber
      })
    }
  }
}
